import React from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ChangePassword from './components/Settings/ChangePassword';
import bgimage from './assets/images/login.jpg';
import './Login.css';

const DASHBOARD_ORG_ROLES = ['ORG_ADMIN', 'MEMBER', 'CISO_RESELLER', 'CPA_AUDITOR', 'CPA_ADMIN'];

function roleHome() {
  const role = localStorage.getItem('role');
  const orgRole = localStorage.getItem('orgRole') || '';
  if (role === 'ROLE_PLATFORM_ADMIN') return '/adminHome';
  if (orgRole === 'CISO_RESELLER') return '/dashboard/reseller';
  if (orgRole === 'CPA_ADMIN' || orgRole === 'CPA_AUDITOR') return '/dashboard/cpa';
  if (role === 'ROLE_USER' || DASHBOARD_ORG_ROLES.includes(orgRole)) return '/dashboard/userHome';
  return '/login';
}

/**
 * Mandatory password change after an admin temp-password reset. Reached right after login
 * when the user record has forcePasswordChange set.
 */
function ForcePasswordChange() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  if (!localStorage.getItem('authToken')) return <Navigate to="/login" replace />;

  return (
    <div className="login-page" style={{ backgroundImage: `url(${bgimage})` }}>
      <div className="login-card">
        <div style={{ padding: '0.5rem 0.25rem' }}>
          <h2 style={{ marginBottom: 6 }}>{t('ForcePasswordChange.heading')}</h2>
          <p style={{ fontSize: '0.875rem', color: '#555', marginBottom: 14 }}>
            {t('ForcePasswordChange.description')}
          </p>
          <ChangePassword forced onSuccess={() => setTimeout(() => navigate(roleHome()), 600)} />
        </div>
      </div>
    </div>
  );
}

export default ForcePasswordChange;
